export type PlatformEnv = "local" | "dev" | "stage";

export const WALLET_ORIGINS: Record<PlatformEnv, string> = {
  local: "http://localhost:5173",
  dev: "https://wallet.compute.dev.ddcdragon.com",
  // The "stage" profile IS the dragon1-testnet cell: the inventories label
  // that cell app_env "stage" (devnet is "dev") and there is no
  // *.stage.ddcdragon.com DNS — the cell's wallet serves at the TEST segment.
  // Resolving this label to a literal stage host embedded a dead origin.
  stage: "https://wallet.compute.test.ddcdragon.com",
};
